import React from 'react'
import Pagination from '@material-ui/lab/Pagination'
import { WithStore } from 'pure-react-carousel'

// The carousel uses zero-based slide indexes,
// while Material UI pagination displays one-based page numbers.
const AppCarouselPagination = React.forwardRef(function AppCarouselPagination(
  { carouselStore, currentSlide, totalSlides, size = 'small', ...props },
  ref,
) {
  if (totalSlides <= 1) return null

  return (
    <Pagination
      ref={ref}
      size={size}
      {...props}
      count={totalSlides}
      page={currentSlide + 1}
      onChange={(event, page) => {
        carouselStore.setStoreState({
          currentSlide: page - 1,
          isPlaying: false,
        })
      }}
    />
  )
})

export default WithStore(AppCarouselPagination, (state) => ({
  currentSlide: state.currentSlide,
  totalSlides: state.totalSlides,
}))
